import { useState, useEffect } from "react";
import { DayPicker } from "react-day-picker";
import "react-day-picker/dist/style.css";
import { Calendar } from "lucide-react";
import { formatDate } from "../../../functions/dateTime/formatDate";
import { formatDateString } from "../../../functions/dateTime/formatDateString";
import useClickOutside from "../../../CustomHooks/useClickOutside";

const BackDate = ({ register, value = "", setValue, isFormClear }) => {
  const { dropdownRef } = useClickOutside(() => serShowDatePicker(-1));
  const [checked, setChecked] = useState(false);
  const [date, setDate] = useState();
  const [showDatePicker, serShowDatePicker] = useState(-1);

  const handleChecked = () => {
    setChecked((WasChecked) => {
      const updatedChecked = !WasChecked;
      if (updatedChecked === false) {
        setValue("date", "");
        setDate();
      }
      return updatedChecked;
    });
  };

  const handleShowDatePicker = () => {
    serShowDatePicker((prevIndex) => (prevIndex === 1 ? -1 : 1));
  };

  useEffect(() => {
    if (date) {
      setValue("date", formatDateString(date), { shouldValidate: true });
    } else {
      setValue("date", "");
    }
  }, [date, setValue]);

  useEffect(() => {
    setChecked(false);
    setDate();
  }, [isFormClear]);

  const today = new Date();
  const disabledDays = {
    after: new Date(today.getFullYear(), today.getMonth(), today.getDate() - 1),
  };

  return (
    <>
      <p className="p-1">
        <input
          type="checkbox"
          id="date"
          className="cursor-pointer accent-input"
          name="date"
          onClick={handleChecked}
          defaultChecked={checked}
        />
        <label
          htmlFor="date"
          className="text-black text-xs lg:text-sm font-poppins cursor-pointer"
        >
          {" "}
          Change Date
        </label>
      </p>
      {checked && (
        <div className="relative mb-2" ref={dropdownRef}>
          <div onClick={handleShowDatePicker} className="cursor-pointer">
            <label
              htmlFor="custom-calendar"
              className="text-xs lg:text-sm font-poppins absolute left-1 lg:left-2 pl-2 pr-3 py-2 top-[1px] lg:top-1 bg-white"
            >
              {date ? formatDate(date) : "Select Date"}
            </label>
            <Calendar
              color="gray"
              className="absolute right-2 top-1 lg:top-3 w-4 lg:w-5"
            />
            <input
              name="date"
              type="text"
              readOnly="readonly"
              value={value}
              className={`w-full border-bw border-lg4 cursor-pointer rounded-md py-1 lg:py-[9px] px-2 lg:px-3 focus-visible:outline-dark-blue`}
              {...register}
            />
          </div>
          {showDatePicker === 1 && (
            <div className="shadow-sh-1 max-w-xs absolute left-0 top-12 bg-white z-9999">
              <DayPicker
                mode="single"
                captionLayout="dropdown"
                defaultMonth={today}
                selected={date}
                onSelect={setDate}
                disabled={disabledDays}
                disableNavigation
                classNames={{
                  caption_label:
                    "font-bold flex items-center mr-3 mb-2 text-xs lg:text-sm",
                  head_row: "flex font-medium text-gray-900 ",
                  head_cell: "w-6 lg:w-7 font-normal text-xs lg:text-sm",
                  row: "flex w-full",
                  cell: "text-gray-600 rounded-md h-6 lg:h-7 w-6 lg:w-7 text-center text-xs lg:text-sm p-0",
                  day: "h-6 lg:h-7 w-6 lg:w-7 p-0 font-normal",
                  day_range_end: "day-range-end",
                  day_selected: "rounded-md focus:bg-gray-900 focus:text-white",
                }}
              />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default BackDate;
